import styled from "@emotion/styled";

export const IconImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 4px;
`;

export const BannerContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const BannerScrollWrapper = styled.div`
  display: flex;
  overflow: scroll;
  max-width: 170px;
  height: 70px;
  gap: 12px;
`;

export const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 4px;
`;
